var $returnFocusTo = window.$returnFocusTo || null;
const $openSearch = $('#open-search');
const $closeSearch = $('#close-search');
const $sectionMenuToggle = $('#section-menu-toggle');

// focus into svg path/use is a thing for some reason
$('svg *').attr('tabindex', -1);

// fix for firefox's lack of :has support.
// as of 8/23 firefox says support is almost ready to ship
// so this and the css rule can be removed at some point
$('blockquote').each(function(){
	if ($(this).find('cite').length) {
		$(this).closest('figure').addClass('has-cite');
	}
});

const closeSearch = function() {
	$openSearch.removeAttr('tabindex');
	$closeSearch.attr('tabindex', -1);
	$b.removeClass('search-open');
}
const closeSectionMenu = function() {
	$sectionMenuToggle.attr('aria-expanded', 'false');
}
const closeModal = function() {
	$('.modal').removeClass('shown');
	$('.modal iframe').each(function(){
		let src = $(this).attr('src');
		$(this).attr('src',src);
	});
}

$('#open-menu').on('click', function(e){
	e.preventDefault();
	$b.addClass('menu-open');
});
$('#close-menu').on('click', function(e){
	e.preventDefault();
	if ($('.menu-item-has-children.active').length) {
		$('.menu-item-has-children').removeClass('active');
		return;
	}
	$b.removeClass('menu-open');
});
$('button.level-1').on('click', function(e){
	if ($w.outerWidth() < window.breakpoints.lg) {
		e.preventDefault();
		$(this).closest('li').addClass('active');
	}
});

$openSearch.on('click', function(e){
	e.preventDefault();
	window.$returnFocusTo = $openSearch;
	$b.addClass('search-open');
	$openSearch.attr('tabindex', -1);
	$closeSearch.removeAttr('tabindex');
	window.helpers.trapFocus('#site-search');
	$('#site-search input').select();
});
$closeSearch.on('click', function(e){
	e.preventDefault();
	closeSearch();
});
$b.on('keyup', function(e){
	if (window.helpers.isEscape(e)) {
		closeModal();
		closeSearch();
		closeSectionMenu();
		window.helpers.returnFocus();
	}
});

$sectionMenuToggle.on('click', function(e){
	e.preventDefault();
	e.stopPropagation();
	if ($(this).attr('aria-expanded') === 'true') {
		closeSectionMenu();
		return;
	}
	window.$returnFocusTo = $(this);
	$(this).attr('aria-expanded', 'true');
	window.helpers.trapFocus('#section-menu');
});
$('#site-main').on('click', closeSectionMenu);

$('.accordion .trigger').on('click', function(e){
	e.preventDefault();
	let $srText = $(this).find('.screen-reader-text');
	if ($(this).attr('aria-expanded') === 'true') {
		$(this).attr('aria-expanded', false);
		$srText.text('Show');
	} else {
		$(this).attr('aria-expanded', true);
		$srText.text('Hide');
	}
});

$('.video-modal-trigger').on('click', function(e){
	e.preventDefault();
	window.$returnFocusTo = $(this);
	window.helpers.trapFocus($(this).data('target'));
	$($(this).data('target')).addClass('shown');
});
$('.modal-close').on('click', function(e){
	e.preventDefault();
	closeModal();
});